<template>
  <SocialsViewWrapper>
    <PublicationsParams />
    <LoaderFullPage v-if="store.loading" />
    <PublicationsData v-else />
  </SocialsViewWrapper>
</template>

<script setup>
import { useRoute, useRouter } from "vue-router";
import SocialsViewWrapper from "@follaw-fr/components/social-media/templates/SocialsViewWrapper.vue";
import PublicationsParams from "@follaw-fr/components/social-media/posts/organisms/PublicationsParams.vue";
import PublicationsData from "@follaw-fr/components/social-media/posts/organisms/PublicationsData.vue";
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import { useSocialMediaStore } from "@follaw-fr/stores/social-media/posts";
import { useUserSettingsStore } from "@follaw-fr/stores/user-settings";
import { PermissionLevel } from "@/follaw-fr/constants/enums/permission-level.enum";

const store = useSocialMediaStore();
const userSettingsStore = useUserSettingsStore();
const router = useRouter();

store.isFollawedActive =
  router.currentRoute.value.fullPath.includes("follawed");

if (userSettingsStore.hasPermission(PermissionLevel.SOCIETAL)) {
  store.selectedFilters.from = 0;
  store.getPublicationsList(useRoute().query.author_id ?? null);
}
</script>
